import React from "react";
import { useHistory } from "react-router-dom";
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
  Flex,
  Box,
  Text,
  Avatar,
  Divider,
  Button,
  Icon,
  Switch,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  FaUsers,
  FaUser,
  FaChartBar,
  FaCreditCard,
  FaMoon,
  FaSignOutAlt,
  FaChevronRight,
} from "react-icons/fa";
import { role as getRole } from "variables/veille";
import { useSession } from "contexts/SessionContext";

function LigneMenu({ icon, label, onClick }) {
  const textColor = useColorModeValue("gray.700", "white");
  return (
    <Flex
      align="center"
      p="12px"
      borderRadius="12px"
      cursor="pointer"
      transition="all .15s"
      _hover={{ bg: useColorModeValue("gray.50", "whiteAlpha.100") }}
      onClick={onClick}
    >
      <Flex w="34px" h="34px" borderRadius="10px" bg="teal.50" align="center" justify="center" me="12px">
        <Icon as={icon} color="teal.500" fontSize="14px" />
      </Flex>
      <Text flex="1" fontSize="sm" fontWeight="medium" color={textColor}>{label}</Text>
      <Icon as={FaChevronRight} color="gray.300" fontSize="12px" />
    </Flex>
  );
}

export default function ProfileDrawer({ isOpen, onClose }) {
  const history = useHistory();
  const { colorMode, toggleColorMode } = useColorMode();
  const textColor = useColorModeValue("gray.700", "white");
  const { profile, role, isAdmin, signOut } = useSession();

  const nom = (profile && profile.full_name) || (profile && profile.email) || "Mon compte";
  const email = (profile && profile.email) || "";
  const roleLabel = (getRole(role) || {}).label;

  const go = (path) => {
    onClose();
    history.push(path);
  };
  const deconnexion = async () => {
    onClose();
    await signOut();
    history.push("/auth/signin");
  };

  return (
    <Drawer isOpen={isOpen} onClose={onClose} placement="right">
      <DrawerOverlay />
      <DrawerContent borderTopLeftRadius="18px" borderBottomLeftRadius="18px">
        <DrawerHeader fontSize="lg" fontWeight="bold" color={textColor}>Mon compte</DrawerHeader>
        <DrawerCloseButton mt="8px" />
        <DrawerBody px="20px">
          {/* Profil */}
          <Flex align="center" mb="20px">
            <Avatar src={(profile && profile.avatar_url) || undefined} name={nom} w="56px" h="56px" me="14px" />
            <Box minW="0">
              <Text fontSize="md" fontWeight="bold" color={textColor} noOfLines={1}>{nom}</Text>
              {roleLabel && <Text fontSize="xs" color="teal.500" fontWeight="bold">{roleLabel}</Text>}
              <Text fontSize="xs" color="gray.500" noOfLines={1}>{email}</Text>
            </Box>
          </Flex>

          <Divider mb="8px" />

          {/* Liens — les pages Équipe et Utilisation sont réservées à l'admin */}
          {isAdmin ? (
            <LigneMenu icon={FaUsers} label="Profil & équipe" onClick={() => go("/admin/equipe")} />
          ) : (
            <LigneMenu icon={FaUser} label="Mon espace" onClick={() => go("/admin/mon-espace")} />
          )}
          <LigneMenu icon={FaChartBar} label="Statistiques" onClick={() => go("/admin/statistiques")} />
          {isAdmin && <LigneMenu icon={FaCreditCard} label="Utilisation" onClick={() => go("/admin/utilisation")} />}

          <Divider my="8px" />

          {/* Apparence */}
          <Flex align="center" p="12px" borderRadius="12px">
            <Flex w="34px" h="34px" borderRadius="10px" bg="teal.50" align="center" justify="center" me="12px">
              <Icon as={FaMoon} color="teal.500" fontSize="14px" />
            </Flex>
            <Text flex="1" fontSize="sm" fontWeight="medium" color={textColor}>Mode sombre</Text>
            <Switch colorScheme="teal" isChecked={colorMode === "dark"} onChange={toggleColorMode} />
          </Flex>

          <Divider my="8px" />

          <Button
            w="100%"
            variant="outline"
            borderColor="red.200"
            color="red.500"
            _hover={{ bg: "red.50" }}
            borderRadius="12px"
            leftIcon={<Icon as={FaSignOutAlt} />}
            mt="8px"
            onClick={deconnexion}
          >
            Se déconnecter
          </Button>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
